import React from "react";
import { Box } from "@mui/material";
import SelectStudents from "./SelectStudents";

const Students: React.FC = () => {
  return (
    <Box
      className="border rounded-2 bg-white my-2 me-2"
      sx={{
        height: "calc(100vh - 20px)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <SelectStudents />
      </Box>
    </Box>
  );
};

export default Students;
